import { render, staticRenderFns } from "./RirekishoLicenseCard.vue?vue&type=template&id=ab63c296&scoped=true"
import script from "./RirekishoLicenseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoLicenseCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoLicenseCard.vue?vue&type=style&index=0&id=ab63c296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab63c296",
  null
  
)

export default component.exports